// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseElement } from './BaseElement';
import { APPComponent } from '../../../../../com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { UIModelComponent } from '../../../../../com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { BEComponent } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { DBComponent } from '../../../../../com/MetaPattern/MDA/MD/DBModel/DBComponent';
import { WorkScope } from './WorkScope';
import { AttachmentFile } from './AttachmentFile';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 应用 实体类
 * APP应用，可单独部署的单元，代表某一特定领域的功能集合
 */
export class APP extends BaseElement {
  /** APPKey : APPKey应用的唯一标识，全局唯一 */
  private _aPPKey: string;

  /** 设置：APPKey */
  public get aPPKey() {
    return this._aPPKey;
  }

  /** 获取：APPKey */
  public set aPPKey(value: string) {
    this._aPPKey = value;
  }

  /** 根名字空间 : 根名字空间 */
  private _rootNamespace: string;

  /** 设置：根名字空间 */
  public get rootNamespace() {
    return this._rootNamespace;
  }

  /** 获取：根名字空间 */
  public set rootNamespace(value: string) {
    this._rootNamespace = value;
  }

  /** 启动端口 : 应用的默认启动端口，在微服务模式下有效 */
  private _startPort: number;

  /** 设置：启动端口 */
  public get startPort() {
    return this._startPort;
  }

  /** 获取：启动端口 */
  public set startPort(value: number) {
    this._startPort = value;
  }

  /** 图标地址 : 应用的图标地址 */
  private _imageUrl: string;

  /** 设置：图标地址 */
  public get imageUrl() {
    return this._imageUrl;
  }

  /** 获取：图标地址 */
  public set imageUrl(value: string) {
    this._imageUrl = value;
  }

  /** 是否系统应该用 : 系统应用是每个产品必备的底层应用，由系统指定，不能修改 */
  private _isSystem: boolean;

  /** 设置：是否系统应该用 */
  public get isSystem() {
    return this._isSystem;
  }

  /** 获取：是否系统应该用 */
  public set isSystem(value: boolean) {
    this._isSystem = value;
  }

  /** 来源应用ID : 当应用通过使用其他应用而来时，记录来源时ID */
  private _sourceAPPId: string;

  /** 设置：来源应用ID */
  public get sourceAPPId() {
    return this._sourceAPPId;
  }

  /** 获取：来源应用ID */
  public set sourceAPPId(value: string) {
    this._sourceAPPId = value;
  }

  /** 应用组件 */
  private _aPPComponents: Array<APPComponent>;

  /** 获取：应用组件 */
  public get aPPComponents() {
    return this._aPPComponents;
  }

  /** 设置：应用组件 */
  public set aPPComponents(value: Array<APPComponent>) {
    this._aPPComponents = value;
  }

  /** 界面模型组件 */
  private _uIModelComponents: Array<UIModelComponent>;

  /** 获取：界面模型组件 */
  public get uIModelComponents() {
    return this._uIModelComponents;
  }

  /** 设置：界面模型组件 */
  public set uIModelComponents(value: Array<UIModelComponent>) {
    this._uIModelComponents = value;
  }

  /** 实体组件 */
  private _bEComponents: Array<BEComponent>;

  /** 获取：实体组件 */
  public get bEComponents() {
    return this._bEComponents;
  }

  /** 设置：实体组件 */
  public set bEComponents(value: Array<BEComponent>) {
    this._bEComponents = value;
  }

  /** 数据库组件 */
  private _dBComponents: Array<DBComponent>;

  /** 获取：数据库组件 */
  public get dBComponents() {
    return this._dBComponents;
  }

  /** 设置：数据库组件 */
  public set dBComponents(value: Array<DBComponent>) {
    this._dBComponents = value;
  }

  /** 工作空间 的ID */
  private _workScope_ID: string;

  /** 获取：工作空间 的ID */
  public get workScope_ID() {
    return this._workScope_ID;
  }

  /** 设置：工作空间 的ID */
  public set workScope_ID(value: string) {
    this._workScope_ID = value;
  }

  /** 工作空间  */
  private _workScope: WorkScope;

  /** 获取：工作空间  */
  public get workScope() {
    return this._workScope;
  }

  /** 设置：工作空间  */
  public set workScope(value: WorkScope) {
    this._workScope = value;
    if (value !== null) {
      this.workScope_ID = value.id;
    } else {
      this.workScope_ID = '';
    }
  }

  /** 附件文件 */
  private _attachmentFiles: Array<AttachmentFile>;

  /** 获取：附件文件 */
  public get attachmentFiles() {
    return this._attachmentFiles;
  }

  /** 设置：附件文件 */
  public set attachmentFiles(value: Array<AttachmentFile>) {
    this._attachmentFiles = value;
  }

  constructor() {
    super();
    this._aPPKey = '';
    this._rootNamespace = '';
    this._startPort = 0;
    this._imageUrl = '';
    this._isSystem = false;
    this._sourceAPPId = '';
    this._aPPComponents = new Array<APPComponent>();
    this._uIModelComponents = new Array<UIModelComponent>();
    this._bEComponents = new Array<BEComponent>();
    this._dBComponents = new Array<DBComponent>();
    this._workScope_ID = '';
    this._workScope = null;
    this._attachmentFiles = new Array<AttachmentFile>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: APP, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.aPPKey = element.aPPKey;
      this.rootNamespace = element.rootNamespace;
      this.startPort = element.startPort;
      this.imageUrl = element.imageUrl;
      this.isSystem = element.isSystem;
      this.sourceAPPId = element.sourceAPPId;
      this.workScope_ID = element.workScope_ID;
      if (hasReference && element.workScope !== null) {
        this.workScope = element.workScope;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.aPPKey = json.APPKey;
    this.rootNamespace = json.RootNamespace;
    this.startPort = json.StartPort;
    this.imageUrl = json.ImageUrl;
    this.isSystem = json.IsSystem;
    this.sourceAPPId = json.SourceAPPId;
    if (json.APPComponents && json.APPComponents.length > 0) {
      json.APPComponents.forEach((element: any) => {
        const aPPComponent = APPComponent.Create(element);
        this.aPPComponents.push(aPPComponent);
      });
    }
    if (json.UIModelComponents && json.UIModelComponents.length > 0) {
      json.UIModelComponents.forEach((element: any) => {
        const uIModelComponent = UIModelComponent.Create(element);
        this.uIModelComponents.push(uIModelComponent);
      });
    }
    if (json.BEComponents && json.BEComponents.length > 0) {
      json.BEComponents.forEach((element: any) => {
        const bEComponent = BEComponent.Create(element);
        this.bEComponents.push(bEComponent);
      });
    }
    if (json.DBComponents && json.DBComponents.length > 0) {
      json.DBComponents.forEach((element: any) => {
        const dBComponent = DBComponent.Create(element);
        this.dBComponents.push(dBComponent);
      });
    }
    this.workScope_ID = json.WorkScope_ID;
    // if (json.WorkScope !== null) {
    //   this.workScope = WorkScope.Create(json.WorkScope);
    // }
    if (json.AttachmentFiles && json.AttachmentFiles.length > 0) {
      json.AttachmentFiles.forEach((element: any) => {
        const attachmentFile = AttachmentFile.Create(element);
        // attachmentFile.aPP = this;
        this.attachmentFiles.push(attachmentFile);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.APPKey = this.aPPKey;
    json.RootNamespace = this.rootNamespace;
    json.StartPort = this.startPort;
    json.ImageUrl = this.imageUrl;
    json.IsSystem = this.isSystem;
    json.SourceAPPId = this.sourceAPPId;
    if (this.aPPComponents && this.aPPComponents.length > 0) {
      json.APPComponents = [];
      this.aPPComponents.forEach((element) => {
        json.APPComponents.push(element.toJson());
      });
    }
    if (this.uIModelComponents && this.uIModelComponents.length > 0) {
      json.UIModelComponents = [];
      this.uIModelComponents.forEach((element) => {
        json.UIModelComponents.push(element.toJson());
      });
    }
    if (this.bEComponents && this.bEComponents.length > 0) {
      json.BEComponents = [];
      this.bEComponents.forEach((element) => {
        json.BEComponents.push(element.toJson());
      });
    }
    if (this.dBComponents && this.dBComponents.length > 0) {
      json.DBComponents = [];
      this.dBComponents.forEach((element) => {
        json.DBComponents.push(element.toJson());
      });
    }
    json.WorkScope_ID = this.workScope_ID;
    if (this.attachmentFiles && this.attachmentFiles.length > 0) {
      json.AttachmentFiles = [];
      this.attachmentFiles.forEach((element) => {
        json.AttachmentFiles.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'aPPKey', 'APPKey', EnumDataType.String, this.aPPKey, true, 'APPKey应用的唯一标识，全局唯一', '', '');
    context.addRow('基本属性', 'rootNamespace', '根名字空间', EnumDataType.String, this.rootNamespace, true, '根名字空间', '', '');
    context.addRow('基本属性', 'imageUrl', '图标地址', EnumDataType.String, this.imageUrl, true, '应用的图标地址', '', '');
    context.addRow('基本属性', 'isSystem', '是否系统应该用', EnumDataType.Bool, this.isSystem, false, '系统应用是每个产品必备的底层应用，由系统指定，不能修改', '', '');
    context.addRow('基本属性', 'workScope', '工作空间', EnumDataType.Reference, this.workScope, true, '', 'WorkScope', 'PGRowWorkScopeValue');
    return context;
  }

  static Create(json: any): APP {
    const aPP = new APP();
    aPP.Deserialize(json);
    aPP.json = json;
    return aPP;
  }
}
